// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"686445ed","787":"18a6d1b6"}[chunkId] + ".chunk.js";
};